import queryString from 'query-string';
import getPath from './pathname';

const QUERY_PARAM_DELIMITER = ',';
const QUERY_SEARCH_DELIMITER = '$';

const asLocation = locationString => {
	const [pathname, search] = locationString.split('?');
	return {
		pathname,
		search: search && `?${search}`
	};
};

const queryEncoder =
	queryName =>
	({ location, to }, oldLocation = null) => {
		let params = {};
		const queryLP = 'lp=1';
		let isLP = false;
		if (oldLocation) {
			// preserve any queryparams that might belong to the main route
			params = oldLocation.query ? oldLocation.query : queryString.parse(oldLocation.search);
			isLP = !!(oldLocation.search && oldLocation.search.includes(queryLP));
		}
		const toLocation = typeof to === 'object' ? to : asLocation(to);

		const path = getPath(location.pathname);

		const toPath = getPath(toLocation.pathname);

		params[queryName] = toPath
			.split('/')
			.filter(truthy => truthy)
			.join(QUERY_PARAM_DELIMITER);

		if (toLocation.search) {
			params[queryName] = `${params[queryName]}${QUERY_SEARCH_DELIMITER}${toLocation.search.substring(1)}`;
		}

		if (!params[queryName]) {
			delete params[queryName];
		}

		if (isLP && params.lp) {
			delete params.lp;
		}

		const search = queryString.stringify(params);

		if (typeof to === 'string') {
			const normalizedPath = path === '' ? '/' : path;
			return search ? `${normalizedPath}?${search}` : `${normalizedPath}`;
		}

		if (typeof location === 'string') {
			return {
				...to,
				pathname: location,
				search: search && `?${search}`
			};
		}

		return {
			...to,
			pathname: path,
			search: search && `?${search}`
		};
	};

const queryDecoder = queryName => {
	const memoized = {
		query: '',
		value: false
	};
	return location => {
		const possibleQuery =
			typeof location === 'string'
				? new URL(location.startsWith('http') ? location : `http://site${location}`).search
				: location.search;

		if (memoized.query === possibleQuery) {
			return memoized.value;
		}
		const query = location.query || queryString.parse(possibleQuery);
		const queryParameterValue = query[queryName];

		memoized.query = possibleQuery || '';
		memoized.value = false;
		if (!queryParameterValue) {
			return false;
		}
		const [path, ...subQuery] = queryParameterValue.split(QUERY_SEARCH_DELIMITER);
		memoized.value = {
			pathname: `${QUERY_PARAM_DELIMITER}${path}`.split(QUERY_PARAM_DELIMITER).join('/'),
			search: subQuery && subQuery.length > 0 ? `?${subQuery.join(QUERY_SEARCH_DELIMITER)}` : ''
		};
		if (memoized.value.search.length > 0) {
			memoized.value.query = queryString.parse(memoized.value.search);
		}

		return memoized.value;
	};
};

/** Deprecated in favor of ContextualPathTransformer */
const pathTransfomer =
	(encoder, decoder, validRoute) =>
	(path, options = {}) => {
		const {
			preserveSidebarState = false, // unfortunate naming :(
			location = window.location
		} = options;
		let transformedPath;
		if (typeof path === 'object') {
			transformedPath = `${path.pathname ? path.pathname : ''}${path.search ? path.search : ''}`;
		} else {
			transformedPath = path;
		}

		if (validRoute(transformedPath)) {
			return encoder(
				{
					location,
					to: transformedPath
				},
				location
			);
		}
		if (!preserveSidebarState) {
			return transformedPath;
		}
		const decoded = decoder(location);
		if (!decoded) {
			return transformedPath;
		}

		return encoder({
			location: {
				pathname: path
			},
			to: `${decoded.pathname}${decoded.search}`
		});
	};

export { queryEncoder, queryDecoder, pathTransfomer };
